import { useState, useEffect } from 'react';
import { useFieldActions } from '../../../../contexts/field-actions-context';
export default function useInitialAppointmentState() {
  const {
    actions,
    formId
  } = useFieldActions();
  const [appointmentState, setAppointmentState] = useState(null);
  useEffect(() => {
    const initialAppointmentState = async () => {
      if (formId && actions != null && actions.queryAvailability) {
        await (actions == null ? void 0 : actions.queryAvailability({
          formId
        }));
        setAppointmentState({});
      }
    };
    initialAppointmentState();
  }, [formId, actions]);
  return appointmentState;
}
//# sourceMappingURL=index.js.map